module.exports = __webpack_public_path__ + "img/taxlogo.260dc731.jpg";